import baseStyles from '../Base/Base.styles'

function toRatio(ratioString) {
  let imageRatio = ratioString.split('/')
  return imageRatio[1] / imageRatio[0] * 100
}

export default ({ base, ratio, maxWidth }) => {
  let jss = {
    root: {
      ...baseStyles(base),
      '& .aspect-ratio-wrapper': {
        paddingTop: `${toRatio(ratio)}%`,
        margin: 'auto'
      },
      '& .video-wrapper': {
        maxWidth: maxWidth ? maxWidth + 'px' : '100%',
      }
    }
  }

  return jss
}
